import { FadeIn, Eyebrow } from "./primitives";

export const EpisodeCanon = ({ episodes }) => (
  <section id="episodes" data-testid="episode-canon-section" className="border-t border-bone/10">
    <div className="mx-auto max-w-6xl px-6 py-24">
      <FadeIn>
        <Eyebrow>The canon</Eyebrow>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-light tracking-tight text-bone sm:text-4xl">
          Every episode starts from a scene you know by heart.
        </h2>
      </FadeIn>

      <div className="mt-16" data-testid="episode-list">
        {episodes.map((ep, index) => (
          <FadeIn key={ep.id} delay={index * 0.05}>
            <div
              data-testid={`episode-row-${ep.number}`}
              className="group grid grid-cols-[3rem_1fr] items-baseline gap-6 border-b border-bone/10 py-7 transition-colors duration-300 hover:border-ruby/40 sm:grid-cols-[5rem_1fr_auto]"
            >
              <span className="font-mono text-sm text-smoke transition-colors duration-300 group-hover:text-ruby">
                {String(ep.number).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-display text-xl font-medium tracking-tight text-bone transition-transform duration-300 group-hover:translate-x-2 sm:text-2xl">
                  {ep.title}
                </h3>
                {ep.note && (
                  <p className="mt-1 font-mono text-xs uppercase tracking-[0.15em] text-smoke">
                    {ep.note}
                  </p>
                )}
              </div>
              <div className="col-start-2 flex items-center gap-5 sm:col-start-auto">
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-smoke">
                  {ep.film}
                </span>
                {ep.watch_url && (
                  <a
                    href={ep.watch_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`episode-watch-${ep.number}`}
                    className="font-mono text-xs uppercase tracking-[0.2em] text-ruby transition-colors duration-300 hover:text-ruby-bright"
                  >
                    Watch
                  </a>
                )}
              </div>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.2}>
        <p className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-smoke">
          ··· The canon is being written — a new question every week
        </p>
      </FadeIn>
    </div>
  </section>
);
